// =============================================================================
// Theme Tokens - Flat Structure
// =============================================================================
//
// Simple flat token definitions: 'component.property' → value per preset
//
// To add a new token:
// 1. Add key to TokenName type
// 2. Add values to TOKENS (ALL presets required)
//
// =============================================================================

import type { ThemePresetId } from './presets'

// -----------------------------------------------------------------------------
// Token Names (flat keys)
// -----------------------------------------------------------------------------

// Add new token names to this union type
export type TokenName = 'testInChatButton.color' | 'viewModeButton.color' | 'pagination.color' | 'documentsTabs.color'

// -----------------------------------------------------------------------------
// Token Value Types
// -----------------------------------------------------------------------------

type ButtonColor = 'primary' | 'secondary' | 'neutral' | 'error'
// type ButtonVariant = 'solid' | 'outline' | 'soft' | 'ghost' | 'link'

// Map token names to their value types
export type TokenValueMap = {
  'testInChatButton.color': ButtonColor
  'viewModeButton.color': ButtonColor
  'pagination.color': ButtonColor
  'documentsTabs.color': ButtonColor
  // Add new mappings here...
}

// -----------------------------------------------------------------------------
// Token Definitions
// -----------------------------------------------------------------------------

// Strict: ALL presets required for each token
type TokenDefinitions = {
  [K in TokenName]: Record<ThemePresetId, TokenValueMap[K]>
}

export const TOKENS: TokenDefinitions = {
  'testInChatButton.color': {
    classic: 'primary',
    midnight: 'secondary',
  },
  'viewModeButton.color': {
    classic: 'primary',
    midnight: 'neutral',
  },
  'pagination.color': {
    classic: 'primary',
    midnight: 'neutral',
  },
  'documentsTabs.color': {
    classic: 'primary',
    midnight: 'secondary',
  },
  // Add new tokens here...
}
